import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import React from 'react';
import PackageSkeleton from './PackageSkeleton';
import {isMobile} from 'react-device-detect';

const SelfCareAbroadPackagesPopularSkeleton = () => {
  return (
    <div className='self-care-abroad-packages-popular-skeleton-wrapper'>
      <div className='self-care-abroad-packages-popular-skeleton'>
        <div className='title'>
          <Skeleton />
        </div>
        <div className='sub-title'>
          <Skeleton />
        </div>
        {!isMobile ? (
          <div className='packages-skeleton-wrapper'>
            <PackageSkeleton />
            <PackageSkeleton />
            <PackageSkeleton />
          </div>
        ) : (
          <div className='packages-skeleton-wrapper'>
            <PackageSkeleton />
          </div>
        )}
      </div>
      <div className='more-packages-button'>
        <Skeleton />
      </div>
    </div>
  );
};

export default SelfCareAbroadPackagesPopularSkeleton;
